/** 从 MIME 类型推断下载用的文件扩展名，猜不出来时兜底成 jpg */
export function mimeToExt(mime?: string | null): string {
  if (!mime) return 'jpg';
  const sub = String(mime).split('/')[1] || '';
  if (sub === 'jpeg') return 'jpg';
  return sub || 'jpg';
}

/** 触发浏览器下载一个已经生成好的 object URL */
export function downloadObjectUrl(url: string, filename: string) {
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
}
